import styled from 'styled-components'

import { COLORS, SIZES } from '~/common/globalStyles'
import Text from '~/views/components/ui/Text'

export const NoticeBar = styled.div<{ color?: string }>`
  height: 30px;
  background-color: ${COLORS.red};
  background-color: ${({ color }) => color || COLORS.red};
  color: ${COLORS.white};
  display: flex;
  align-items: center;
  padding: 0 ${SIZES.large};
`

export const NoticeText = styled(Text)`
  flex: 1;
`
